import { queryOptions, useQuery } from "@tanstack/react-query"
import { getThought, getThoughts } from "./client"
import { thoughtKeys } from "./keys"

export function thoughtsQueryOptions(userId: number) {
	return queryOptions({
		queryKey: thoughtKeys.list(userId),
		queryFn: () => getThoughts(userId),
		staleTime: 10 * 60 * 1000,
	})
}

export function thoughtQueryOptions(userId: number, thoughtId: number) {
	return queryOptions({
		queryKey: thoughtKeys.detail(userId, thoughtId),
		queryFn: () => getThought(userId, thoughtId),
		staleTime: 10 * 60 * 1000,
	})
}

/**
 * Hook для получения списка thoughts
 * GET /{user_id}/thoughts
 */
export function useThoughts(userId: number) {
	return useQuery(thoughtsQueryOptions(userId))
}

/**
 * Hook для получения одной thought
 * GET /{user_id}/thoughts/{thought_id}
 */
export function useThought(userId: number, thoughtId: number) {
	return useQuery({
		...thoughtQueryOptions(userId, thoughtId),
		// Всегда делать запрос при открытии записи — бэкенд автоматически
		// помечает как прочитанное при GET запросе
		refetchOnMount: "always",
	})
}
